module.exports = __webpack_public_path__ + "static/media/calculator.79cb0170.svg";